// Entry point for the build script in your package.json
import { Turbo } from '@hotwired/turbo-rails'

// Custom Turbo Stream action: full-page navigation
// Usage: turbo_stream.action(:redirect, url)
Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.getAttribute('target'))
}
import 'flowbite/dist/flowbite.turbo'
import $ from 'jquery'
import 'jquery-modal'

import './channels'
import './color'
import './controllers'
import './notifications/declarative_web_push'
import { reloadOnReturnFromIdle } from './idle_reload'
import './svg_render'
import { isMobile, isPwa } from './utilities'
import { FirebaseNotificationManager } from './notifications/firebase_notifications'

window.jQuery = $
window.$ = $

// Custom click events
document.addEventListener('click', (event) => {
  // Fade in button
  if (event.target.matches('[data-fade-in-id]')) {
    $(event.target).hide()
    $('#' + $(event.target).data('fade-in-id')).fadeIn(250)
  }

  // Toggle button
  const showHideTarget = event.target.closest('[data-show-hide-id]')
  if (showHideTarget) {
    const elem = $('#' + $(showHideTarget).data('show-hide-id'))
    elem.toggleClass('hidden')
  }

  // Fade Toggle button
  const fadeShowHideTarget = event.target.closest('[data-fade-show-hide-id]')
  if (fadeShowHideTarget) {
    const elem = $('#' + $(fadeShowHideTarget).data('fade-show-hide-id'))
    elem.fadeToggle(250)
  }

  // Slide in button
  const slideInTarget = event.target.closest('[data-slide-in-id]')
  if (slideInTarget) {
    const elem = $('#' + $(slideInTarget).data('slide-in-id'))
    elem.slideToggle(250)
  }

  // Rotatable buttons
  if (event.target.matches('[data-rotate]')) {
    const button = $(event.target)
    let target = button
    if ($(event.target).data('rotate-id') !== undefined) {
      target = $(`#${$(event.target).data('rotate-id')}`)
    }

    switch ($(button).data('rotate')) {
      case 'ccw':
        if ($(target).data('rotated')) {
          $(target).css({ transform: 'rotate(0deg)', transition: 'transform 250ms' })
          $(target).data('rotated', false)
        } else {
          $(target).css({ transform: 'rotate(-90deg)', transition: 'transform 250ms' })
          $(target).data('rotated', true)
        }
        break
      case 'cw':
        if ($(target).data('rotated')) {
          $(target).css({ transform: 'rotate(0deg)', transition: 'transform 250ms' })
          $(target).data('rotated', false)
        } else {
          $(target).css({ transform: 'rotate(90deg)', transition: 'transform 250ms' })
          $(target).data('rotated', true)
        }
        break
    }
  }

  // Hidable button
  if (event.target.matches('[data-hide-on-click]')) {
    $(event.target).toggleClass('hidden')
  }

  // Copy to clipboard
  if (event.target.matches('[data-copy-url]')) {
    const target = $(event.target).data('copy-url')
    navigator.clipboard.writeText(target)
      .then(() => {
        $(event.target).text('Copied to the clipboard!')
      })
      .catch((error) => {
        console.error('Failed to copy to the clipboard:', error)
      })
  }
})

// Idle reload
reloadOnReturnFromIdle()

// Turbo fades
window.addEventListener('turbo:before-frame-render', (event) => {
  if (document.startViewTransition) {
    const originalRender = event.detail.render
    event.detail.render = (currentElement, newElement) => {
      document.startViewTransition(() => originalRender(currentElement, newElement))
    }
  }
})

window.addEventListener('turbo:before-stream-render', (event) => {
  // Scroll to top if target is home_screen
  if ($(event.srcElement).attr('target') === 'home_screen') {
    window.scrollTo({ top: 0 })
  }

  // Add Turbo Fade
  if (document.startViewTransition) {
    const originalRender = event.detail.render
    event.detail.render = (currentElement, newElement) => {
      document.startViewTransition(() => originalRender(currentElement, newElement))
    }
  }

  // Add hide on max children
  const targetString = $(event.srcElement).attr('target')
  const targetElem = $(`#${targetString}`)
  const elemToCheck = [targetElem, targetElem.parent()]

  const turboAction = $(event.srcElement).attr('action')
  let elemDelta = 0
  if (turboAction.includes('append')) {
    elemDelta++
  } else if (turboAction.includes('remove')) {
    elemDelta--
  }

  elemToCheck.forEach((elem) => {
    if (elem.data('max-children') !== undefined) {
      const max = elem.data('max-children')
      const newCount = elem.children().length + elemDelta
      const hideId = elem.data('hide-id')
      const hideElem = $(`#${hideId}`)

      if (newCount >= max) {
        hideElem.addClass('hidden')
      } else {
        hideElem.removeClass('hidden')
      }
    }
  })
})

// Resize text areas
function resizeTextarea (textarea) {
  textarea.style.height = 'auto'
  textarea.style.height = textarea.scrollHeight + 'px'
}

function applyAutosize () {
  const textareas = document.querySelectorAll('textarea.auto-resize')

  textareas.forEach(textarea => {
    textarea.removeEventListener('input', resizeTextarea)
    textarea.addEventListener('input', () => resizeTextarea(textarea))
    // Only resize immediately when the textarea already has content (e.g. edit
    // forms). Empty textareas keep their rows-attribute height so they are not
    // inflated by a zero-width container during a CSS width transition.
    if (textarea.value.trim() !== '') {
      resizeTextarea(textarea)
    }
  })
}

document.addEventListener('turbo:load', () => {
  applyAutosize()
})

// Update textareas after Turbo Stream replace actions
const afterRenderEvent = new Event('turbo:after-stream-render')
document.addEventListener('turbo:before-stream-render', (event) => {
  const originalRender = event.detail.render

  event.detail.render = function (streamElement) {
    originalRender(streamElement)
    document.dispatchEvent(afterRenderEvent)
  }
})

document.addEventListener('turbo:after-stream-render', (event) => {
  applyAutosize()
  scrollPrayerUpdatesToBottom()
})

// Scroll prayer request updates to bottom when needed
function scrollPrayerUpdatesToBottom () {
  const containers = document.querySelectorAll('[data-scroll-to-bottom="true"]')
  containers.forEach(container => {
    container.scrollTop = container.scrollHeight
  })
  updateScrollGradients()
}

// Show/hide gradient based on whether content is scrollable
function updateScrollGradients () {
  const scrollContainers = document.querySelectorAll('.updates-scroll-container')
  scrollContainers.forEach(wrapper => {
    const content = wrapper.querySelector('.updates-scroll-content')
    const gradient = wrapper.querySelector('.updates-scroll-gradient')

    if (content && gradient) {
      // Check if content height exceeds container height (is scrollable)
      if (content.scrollHeight > content.clientHeight) {
        gradient.classList.remove('hidden')
      } else {
        gradient.classList.add('hidden')
      }
    }
  })
}

document.addEventListener('turbo:load', () => {
  scrollPrayerUpdatesToBottom()
  updateScrollGradients()
})

document.addEventListener('turbo:frame-load', () => {
  applyAutosize()
  scrollPrayerUpdatesToBottom()
  updateScrollGradients()
})

document.addEventListener('DOMContentLoaded', function () {
  // Scroll to bottom of dj activity feeds by default
  const div = document.getElementById('journey_activity_feed')
  if (div) {
    div.scrollTop = div.scrollHeight
  }

  // Initialize Firebase foreground notifications
  initializeFirebaseNotifications()

  // Keep --toolbar-height CSS variable in sync with the actual rendered height
  // of the fixed page toolbar bar. Used by the sidebar to compute its height.
  const toolbarBar = document.getElementById('page-toolbar-bar')
  if (toolbarBar) {
    const updateToolbarHeight = () => {
      document.documentElement.style.setProperty(
        '--toolbar-height',
        toolbarBar.offsetHeight + 'px'
      )
    }
    updateToolbarHeight()
    new ResizeObserver(updateToolbarHeight).observe(toolbarBar)
  }
})

async function initializeFirebaseNotifications () {
  try {
    const supported = FirebaseNotificationManager.isSupported()
    if (supported === true && window.Notification && Notification.permission === 'granted') {
      await FirebaseNotificationManager.initialize()
      console.log('[App] Firebase foreground notifications initialized')
    }
  } catch (err) {
    console.log('[App] Firebase notifications not initialized:', err.message)
  }
}

export function updateFileName (input, id, defaultText = 'Choose File') {
  let fileName = input.files[0]?.name || defaultText
  if (fileName !== defaultText) {
    fileName = fileName.replace(/.*[\/\\]/, '')
    fileName = fileName.length > 20 ? fileName.slice(0, 17) + '...' : fileName
  }
  document.getElementById(id).textContent = fileName
}

window.updateFileName = updateFileName
